import { createSlice } from "@reduxjs/toolkit";
import { fetchPharmacyTransactionHistoryReducer } from "../../reducer/pharmacyWallet/fetchPharmacyTransactionHistoryReducer";

import i18n from "../../i18n";
const initialState = {
  isLoading: false,
  data: {
    transactions: [],
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
      total_pages: 0,
    },
    total_earnings: 0,
  },
  error: null,
};

const pharmacyTransactionHistorySlice = createSlice({
  name: "pharmacyTransactionHistory",
  initialState,
  reducers: {
    clearTransactionHistory: (state) => {
      state.data = initialState.data;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPharmacyTransactionHistoryReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        fetchPharmacyTransactionHistoryReducer.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.data = action.payload || initialState.data;
          console.log(
            "✅ Pharmacy Transaction History Loaded:",
            action.payload,
          );
        },
      )
      .addCase(
        fetchPharmacyTransactionHistoryReducer.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error =
            action.payload || i18n.t("pharmacy.toast.failedToLoadPharmacyTransactionHistory");
        },
      );
  },
});

export const { clearTransactionHistory } =
  pharmacyTransactionHistorySlice.actions;
export default pharmacyTransactionHistorySlice.reducer;
